export const locale = {
    lang: 'pl',
    data: {
        'Devices': 'Urządzenia',
        'New': 'Nowe',
        'Edit': 'Edycja',
        'Name': 'Nazwa',
        'Serial number': 'Numer seryjny',
        'Active': 'Aktywne',
        'Registered': 'Zarejestrowane',
        'Actions': 'Akcje',
    }
};
